// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ_PACKAGE_SIZE_DETAIL_DEFAULT_LARGE = "Max 3 kg, \u0160+V+H \u2264 250 cm, max strana \u2264 100 cm, box 69 x 58 x 45 cm";
export const BZ_PACKAGE_SIZE_DETAIL_DEFAULT_MEDIUM = "Max 2 kg, \u0160+V+H \u2264 250 cm, max strana \u2264 100 cm, box 69 x 58 x 45 cm";
export const BZ_PACKAGE_SIZE_DETAIL_DEFAULT_SMALL = "(mal\u00fd bal\u00edk)";
export const BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_LARGE = "(t\u011b\u017e\u0161\u00ed boty, v\u011bt\u0161\u00ed koza\u010dky)";
export const BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_MEDIUM = "(tenisky, baler\u00edny, boti\u010dky)";
export const BZ_PACKAGE_SIZE_LARGE_detail = "Velk\u00e1 %(detail)s";
export const BZ_PACKAGE_SIZE_MEDIUM_detail = "St\u0159edn\u00ed %(detail)s";
export const BZ_PACKAGE_SIZE_SMALL_detail = "Mal\u00e1 %(detail)s";
